import { render } from "./composite-chart.vue?vue&type=template&id=22d524d7"
import script from "./composite-chart.vue?vue&type=script&lang=ts"
export * from "./composite-chart.vue?vue&type=script&lang=ts"
script.render = render

export default script